/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Sort } from "@angular/material/sort";
import { patchState, signalStoreFeature, withMethods, withState } from "@ngrx/signals";
import { StoreCollection } from "src/app/enums";

export interface SortState<K extends StoreCollection> {
  sorts: Record<K, Sort>;
}

export function withSort<K extends StoreCollection>(initialState: SortState<K>) {
  return signalStoreFeature(
    withState<SortState<K>>(initialState),
    withMethods(store => ({
      setSort(sort: Sort, collection: K): void {
        patchState(store, {
          sorts: {
            ...store.sorts(),
            [collection]: sort,
          },
        });
      },
    })),
  );
}
